module.exports = __webpack_public_path__ + "static/img/DLD_24Q4CRM_Used.576b7c2.jpg";